import { createFileRoute } from '@tanstack/react-router'

import { LiquidityOverview } from '@/components/Redeem/LiquidityOverview'
import { withStaticTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/redeem/buckets')({
  component: BucketsPage,
  head: withStaticTitle('Buckets'),
})

function BucketsPage() {
  return <LiquidityOverview />
}
